import React from 'react';
import './contentResults.scss';

import EmailDropdown from '../emailDropdown/emailDropdown';
import ContentResult from '../resultDisplay/contentResult/contentResult';


import check from '../../../assets/check.svg';

class ContentResults extends React.Component {
    render() {
        const { modal, headerInfo, site } = this.props;
        
        return (
            <>
                <div className={`done-banner default ${site}`}>
                    <img className="check icon" src={check} alt="" />
                    <div className="banner-message">Done! Scroll down to see your results.</div>
                </div>

                <div className="main-results-container default">


                    <div className="results">
                        <div className="content-container">
                            <ContentResult />
                        </div>

                        <EmailDropdown />
                    </div>
                </div>
            </>
        );
    }
}

export default ContentResults;
